import { Timeline, type TimelineEvent } from '@procurify/ui'

export interface ApprovalHistoryEvent extends TimelineEvent {}

export interface IApprovalHistoryProps {
  approvalHistory: ApprovalHistoryEvent[]
}

export const ApprovalHistory = ({ approvalHistory }: IApprovalHistoryProps) => {
  return <Timeline data={approvalHistory} />
}
